/**
 * Shown while Clerk loads and while `/users/me` resolves.
 *
 * Deliberately plain: it renders before the app has decided anything, including whether
 * the user is allowed to see the shell.
 */
export function AppSplash({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      className="bg-bg text-fg grid min-h-dvh place-items-center"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="border-separator border-t-accent size-6 animate-spin rounded-full border-2 motion-reduce:animate-none" />
        <span className="text-fg-muted text-[13px]">{label}</span>
      </div>
    </div>
  );
}
